// extracted by mini-css-extract-plugin
export default {"mn-record-info-card":"index_mn-record-info-card__1-wSE"};